import type { TimelineEvent } from '@/components/AssetHistoryTimeline';

type Person = { firstName: string; lastName: string };
export interface AssetHistoryRecord {
  id: number;
  name: string;
  createdAt: string;
  inspections: Array<{ id: number; date: string; status: string; notes?: string | null; damageDescription?: string | null; severity?: string | null; photoUrls?: unknown; inspector?: Person }>;
  assignments: Array<{ id: number; issuedAt: string; returnedAt?: string | null; notes?: string | null; user?: Person }>;
}

/** Only persisted events belong in a compliance history. Never infer dates or passes. */
export function assetHistoryEvents(asset: AssetHistoryRecord): TimelineEvent[] {
  const events: TimelineEvent[] = [{ id: `created-${asset.id}`, type: 'created', date: asset.createdAt, title: 'Asset Created', description: `${asset.name} added to inventory.` }];
  for (const inspection of asset.inspections) {
    const status = ['PASS', 'FAIL', 'NEEDS_REPAIR', 'CALIBRATED'].includes(inspection.status)
      ? inspection.status as TimelineEvent['status'] : undefined;
    events.push({ id: `inspection-${inspection.id}`, type: 'inspection', date: inspection.date,
      title: 'Inspection Recorded', description: inspection.damageDescription || inspection.notes || 'No inspection notes recorded.',
      status, user: inspection.inspector, severity: inspection.severity || undefined,
      photoUrls: Array.isArray(inspection.photoUrls) ? inspection.photoUrls.filter((url): url is string => typeof url === 'string') : undefined });
  }
  for (const assignment of asset.assignments) {
    events.push({ id: `assignment-${assignment.id}`, type: 'assignment', date: assignment.issuedAt,
      title: 'Asset Assigned', description: assignment.notes || 'Equipment checked out.', user: assignment.user });
    if (assignment.returnedAt) events.push({ id: `return-${assignment.id}`, type: 'assignment', date: assignment.returnedAt,
      title: 'Asset Returned', description: 'Equipment checked in.', user: assignment.user });
  }
  return events.sort((a, b) => Date.parse(b.date) - Date.parse(a.date));
}
